import { tablePadding } from "@core/table";
import { tokens } from "@core/theme/tokens";

// Mismo criterio de medidas que la Bitácora de accesos (accessLogStyles.ts):
// no hay prototipo propio para esta pantalla, así que se reutilizan los
// primitivos y proporciones ya validados de esa hermana. La barra de
// filtros, el input de filtro y el diálogo de "Filtros adicionales" son
// idénticos a los de `accessLogStyles.ts` — viven en
// `@portal/common/securityLogStyles` (jscpd, revisión de duplicación
// 2026-09-23).
export const httpRequestLogStyles = {
  methodText: {
    font: `600 11.5px ${tokens.font.ui}`,
    color: tokens.text.secondary,
    letterSpacing: "0.04em",
  },
  pathText: {
    font: `400 12px ${tokens.font.ui}`,
    color: tokens.text.primary,
    wordBreak: "break-all" as const,
  },
  successBadge: {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    whiteSpace: "nowrap",
    padding: "6px 11px",
    borderRadius: 999,
    border: "1px solid rgba(232,234,238,0.28)",
    background: "rgba(232,234,238,0.12)",
    color: "#DDDFE3",
    font: `600 11px/1 ${tokens.font.ui}`,
  },
  errorBadge: {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    whiteSpace: "nowrap",
    padding: "6px 11px",
    borderRadius: 999,
    border: "1px solid rgba(214,124,104,0.34)",
    background: "rgba(214,124,104,0.13)",
    color: tokens.danger.base,
    font: `600 11px/1 ${tokens.font.ui}`,
  },
  exceptionMark: {
    color: tokens.danger.base,
    font: `600 13px ${tokens.font.ui}`,
  },
  table: {
    minWidth: 1120,
    headerPadding: tablePadding("18px", "11px"),
    rowPadding: tablePadding("12px"),
  },
  advancedFilters: {
    toggleRow: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      color: tokens.text.tertiary,
      font: `500 11.5px ${tokens.font.ui}`,
    },
  },
  detail: {
    section: {
      border: `1px solid ${tokens.surface.line}`,
      borderRadius: tokens.radius.sm,
      overflow: "hidden" as const,
      marginBottom: 16,
    },
    sectionTitle: {
      padding: "14px 16px 10px",
    },
    sectionBody: {
      padding: "0 16px 14px",
    },
    summaryGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px 14px",
    },
    fieldLabel: {
      fontSize: 9.5,
      marginBottom: 4,
    },
    fieldValue: {
      font: `400 12.5px ${tokens.font.ui}`,
      color: tokens.text.secondary,
      wordBreak: "break-all" as const,
    },
    // JSON legible: monoespaciado, con salto de línea y scroll propio en vez
    // de empujar el panel — un `request_body` grande no puede volver
    // inmanejable el resto del detalle.
    json: {
      margin: 0,
      padding: 12,
      maxHeight: 260,
      overflow: "auto",
      background: tokens.surface.bg2,
      border: `1px solid ${tokens.surface.line}`,
      borderRadius: tokens.radius.sm,
      color: tokens.text.secondary,
      font: "400 11.5px/1.55 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
      whiteSpace: "pre-wrap" as const,
      wordBreak: "break-all" as const,
    },
  },
} as const;
